module.exports = __webpack_public_path__ + "img/jordbruk_smvf.c4bf1a24.jpg";